<template>
  <modal
    ref="modal"
    :show="viewOrderModalDisplayed"
    effect="fade"
    ok-text="Refund"
    @closeOnEscape="closeModal"
  >
    <div
      slot="modal-header"
      class="modal-header"
    >
      <button
        type="button"
        class="close"
        @click="closeModal()"
      >
        <span>&times;</span>
      </button>
      <h4 class="modal-title center">
        Order No. {{ order.external_id }}
      </h4>
    </div>
    <div
      slot="modal-body"
      class="modal-body"
    >
      <div class="portlet-body">
        <div class="row">
          <div class="col-md-12">
            <div
              v-show="errorMessage"
              ref="errorMessage"
              class="alert alert-danger"
            >
              <button
                class="close"
                @click="clearError()"
              />
              <span>{{ errorMessage }}</span>
            </div>
          </div>
        </div>
        <table class="table table-striped table-bordered table-advance table-hover">
          <tbody>
            <tr>
              <th> Items </th>
              <td>
                <span v-if="order.order_items.length === 0">
                  -
                </span>
                <ul class="list-unstyled">
                  <li
                    v-for="(item, index1) in order.order_items"
                    :key="index1"
                  >
                    {{ item.name }} x {{ item.item_qty }} ({{ formatUSD(item.item_price) }})
                    <ul>
                      <li
                        v-for="(modifier, index2) in item.modifier"
                        :key="index2"
                      >
                        {{ modifier.name }}
                        <span v-if="modifier.mod_qty !== 1">
                          x {{ modifier.mod_qty }}
                        </span>
                        <span v-if="modifier.order_modifier_option.length">
                          (
                        </span>
                        <span
                          v-for="(option, optionIndex) in modifier.order_modifier_option"
                          :key="optionIndex"
                        >
                          {{ option.option_name }}
                          <span v-if="optionIndex !== modifier.order_modifier_option.length - 1">
                            ,
                          </span>
                        </span>
                        <span v-if="modifier.order_modifier_portion && modifier.order_modifier_portion.length">
                          ;
                        </span>
                        <span
                          v-for="(portion, portionIndex) in modifier.order_modifier_portion"
                          :key="portionIndex"
                        >
                          {{ portion.portion_name }}
                          <span v-if="portionIndex !== modifier.order_modifier_portion.length - 1">
                            ,
                          </span>
                        </span>
                        <span v-if="modifier.order_modifier_option.length">
                          )
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th> Store </th>
              <td> {{ order.location_name }} </td>
            </tr>
            <tr>
              <th> Status </th>
              <td> {{ order.status }} </td>
            </tr>
            <tr>
              <th> Type </th>
              <td> {{ order.order_type }} </td>
            </tr>
            <tr>
              <th> Group order </th>
              <td>
                <span v-if="order.grouporder_id !== 0">
                  {{ order.grouporder_id }}
                </span>
                <span v-else>
                  no
                </span>
              </td>
            </tr>
            <tr v-if="order.type === 'pickup' && order.pickup_later === 1">
              <th> Pickup time </th>
              <td> {{ order.pickup_time }} </td>
            </tr>
            <tr>
              <th> Delivery fee </th>
              <td> {{ formatUSD(order.delivery_fee) }} </td>
            </tr>
            <tr>
              <th> Delivery tax </th>
              <td> {{ formatUSD(order.delivery_tax) }} </td>
            </tr>
            <tr>
              <th> Reward </th>
              <td> {{ formatUSD(getRewardAmount(order)) }} </td>
            </tr>
            <tr>
              <th> Promotions </th>
              <td> {{ formatUSD(order.promocode_amount) }} </td>
            </tr>
            <tr>
              <th> Gift card redemption </th>
              <td> {{ formatUSD(order.giftcard_amount) }} </td>
            </tr>
            <tr>
              <th> Rewards total </th>
              <td> {{ formatUSD(order.total_reward) }} </td>
            </tr>
            <tr>
              <th> Tip </th>
              <td> {{ formatUSD(order.tip_amount) }} </td>
            </tr>
            <tr>
              <th> Tax </th>
              <td> {{ formatUSD(order.tax_amount) }} </td>
            </tr>
            <tr>
              <th> Total </th>
              <td> {{ formatUSD(order.total) }} </td>
            </tr>
            <tr>
              <th> Notes </th>
              <td> {{ order.note || '-' }} </td>
            </tr>
            <tr>
              <th> Points earned </th>
              <td> {{ order.points_earned }} </td>
            </tr>
            <tr>
              <th> Created at </th>
              <td> {{ order.created_at }} </td>
            </tr>
            <tr>
              <th> Updated at </th>
              <td> {{ order.updated_at }} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      slot="modal-footer"
      class="modal-footer"
    >
      <button
        v-if="
          order.status !== 'refunded' &&
            !(order.status !== 'completed' && order.paid === 0) &&
            $root.permissions['order_refund']
        "
        type="button"
        class="btn btn-primary pull-left"
        :disabled="refunding"
        @click="refund()"
      >
        Refund
        <i
          v-show="refunding"
          class="fa fa-spinner fa-pulse fa-fw"
        />
      </button>
      <button
        type="button"
        class="btn btn-default"
        @click="closeModal()"
      >
        Close
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '../../modules/Modal'
import UsersFunctions from '../../../controllers/Users'
import ajaxErrorHandler from '@/controllers/ErrorController'

export default {
  components: {
    Modal
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      viewOrderModalDisplayed: false,
      refunding: false,
      errorMessage: ''
    }
  },
  mounted () {
    this.viewOrderModalDisplayed = true
  },
  methods: {
    /**
     * To calculate the amount paid with points
     * @function
     * @returns {undefined}
     */
    getRewardAmount (order) {
      try {
        return parseFloat(order.reward_amount) - parseFloat(order.promocode_amount)
      } catch {
        return ''
      }
    },
    /**
     * To close the modal.
     * @function
     * @returns {undefined}
     */
    closeModal () {
      this.$emit('closeViewOrderModal')
    },
    /**
     * To clear the error.
     * @function
     * @returns {undefined}
     */
    clearError () {
      this.errorMessage = ''
    },
    /**
     * To format a number as currency
     * @function
     * @param {string} val - The number to format
     * @returns {string} The formatted currency amount
     */
    formatUSD (val = '') {
      if (val !== null && val !== undefined) {
        let local = Number(val)
        local = local.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        })
        return local
      } else {
        return 'n/a'
      }
    },
    /**
     * To refund the order.
     * @function
     * @returns {undefined}
     */
    refund () {
      this.refunding = true
      var viewOrderVue = this

      UsersFunctions.refundOrder(
        viewOrderVue.$root.appId,
        viewOrderVue.$root.appSecret,
        viewOrderVue.$root.userToken,
        viewOrderVue.order.id
      )
        .then(response => {
          if (response.code === 200 && response.status === 'ok') {
            viewOrderVue.showRefundSuccess(response.payload)
          } else {
            viewOrderVue.errorMessage = 'Could not refund this order'
            window.scrollTo(0, 0)
          }
          if (response && response.payload && response.payload.pending_approval !== true) {
            viewOrderVue.order.status = 'refunded'
            viewOrderVue.$emit('statusChanged', viewOrderVue.order.status)
          }
        })
        .catch(reason => {
          ajaxErrorHandler({
            reason,
            errorText: 'We could not refund the order',
            errorName: 'errorMessage',
            vue: viewOrderVue,
            containerRef: 'modal'
          })
        })
        .finally(() => {
          viewOrderVue.refunding = false
        })
    },
    /**
     * To notify user of the outcome of the call
     * @function
     * @param {object} payload - The payload object from the server response
     * @returns {undefined}
     */
    showRefundSuccess (payload = {}) {
      let title = 'Success'
      let text = 'The order has been refunded'
      let type = 'success'

      if (payload && payload.pending_approval) {
        title = 'Approval Required'
        text = 'The change has been sent for approval'
        type = 'info'
      }

      this.$swal({
        title,
        text,
        type
      })
    }
  }
}
</script>

<style scoped>
.item-name {
  font-weight: 700;
}
</style>
